// extracted by mini-css-extract-plugin
export var footer = "_m2-5";
export var fulfillmentInput = "_m2-0";
export var shipDateInput = "_m2-1";
export var shipmentModal = "_m2-2";
export var shipmentModalContent = "_m2-3";
export var tableContainer = "_m2-4";